import React from "react";
import {
  Box,
  Typography,
  FormControl,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchResult from "../../components/SearchResult";
import ApiService from "../../services/api-service";
import Loader from "./../../components/Loader";
import PageHeader from "../../components/PageHeader";
import OutsideClickHandler from "react-outside-click-handler";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import { useTranslation } from "react-i18next";
import './index.css'; // Ensure this path is correct

export default function Search({ showClose }) {
  const { t } = useTranslation("common");
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [selectedId, setSelectedAlbum] = React.useState();
  const [focus, setFocus] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState([]);
  const [playlist, setPlaylist] = React.useState([]);
  const [music, setMusic] = React.useState([]);
  const [keyword, setKeyword] = React.useState("");
  const [isTyping, setIsTyping] = React.useState(false);

  const handleSearch = async (keyword) => {
    if (keyword) {
      try {
        setLoading(true);
        const response = await ApiService.SEARCH(keyword);
        setMusic([...response["result"]["music"]]);
        setPlaylist([...response["result"]["studio"]]);
        setUser([...response["result"]["artist"]]);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    }
  };

  var typingTimer;
  var doneTypingInterval = 1000;

  const onKeyup = () => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
    setIsTyping(false);
  };

  const onKeydown = () => {
    clearTimeout(typingTimer);
    setIsTyping(true);
  };

  function doneTyping() {
    setFocus(true);
    if (keyword.length >= 1) {
      handleSearch(keyword);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: 'flex-end',
        width: showClose ? "100%" : "80%",
        minWidth: "200px",
        maxWidth: "500px",
        position: "relative",
        height: "auto",
        paddingLeft: "18px",
        paddingRight: "18px",
      }}
    >
      {focus ? (
        <OutsideClickHandler
          onOutsideClick={() => {
            setKeyword("");
            setFocus(false);
          }}
        >
          <SearchResult
           handleClose={() => {
              setKeyword("");
              setFocus(false);
            }}
            keyword={keyword}
            users={user}
            musics={music}
            playlists={playlist}
            onShowAddPlaylist={(musicId, show) => {
              setSelectedAlbum(musicId);
              setShowPlaylist(show);
            }}
            style={{ maxHeight: '80vh', overflowY: 'auto' }} // Ensure scroll behavior for large content
          />
        </OutsideClickHandler>
      ) : null}

      <div className={`search-input-container`}>
        <OutlinedInput
          sx={{
            width: showClose ? "100%" : "80%",
            borderRadius: "25px",
            height: "42px",
          }}
          id="search-input"
          className={`search-input ${focus ? "focused" : ""}`}
          placeholder={t("header.search")}
          value={keyword}
          onChange={(e) => (setKeyword(e.target.value), setFocus(true))}
          onKeyUp={onKeyup}
          onKeyDown={onKeydown}
          startAdornment={
            <InputAdornment position="start" id="_search_icon">
              {showClose ?? <SearchIcon />}
            </InputAdornment>
          }
          aria-describedby="outlined-weight-helper-text"
          inputProps={{
            "aria-label": "Search Artist, Song, Studio Name",
          }}
          autoComplete="off"
        />
      </div>

      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => {
            setShowPlaylist(false);
          }}
        />
      ) : null}
    </Box>
  );
}